import { DEFAULT_ALIGNER_FIELDS } from '@odo/shared-ui/clinical/alignerFields';
import type { ClinicalFormData, ClinicalSubmitArgs } from './clinicalWizardConfig';

// Fields shared by the RDI/SDI submit and edit routes; callers add their own PDF file id.
export function buildClinicalSubmitBody<T extends ClinicalFormData>(
    payload: ClinicalSubmitArgs<T>
): Record<string, unknown> {
    return {
        formData: payload.formData,
        patientName: payload.patientName,
        elasticsEnabled: payload.toggles.elasticsEnabled,
        alignerScheduleEnabled: payload.toggles.alignerScheduleEnabled,
        alignerFields: payload.toggles.alignerFields ?? DEFAULT_ALIGNER_FIELDS,
        ...(payload.virtualAppointments !== undefined && {
            virtualAppointments: payload.virtualAppointments
        }),
        ...(payload.draftId && { draftId: payload.draftId }),
        ...(payload.manufacturerPdfRef && { manufacturerPdf: payload.manufacturerPdfRef })
    };
}
